<template>
  <v-row no-gutters>
    <v-col>
        <v-toolbar dense :elevation="0" :class="windowWidth > 670 ? 'toolbar-wrap' : 'rpd-toolbar'">
          <div class="text-primary-700" style="font-weight: 700; display: grid;">
            <span style="font-size: large">Companies</span>  
            <span style="margin-top:-10px">
              <a href="https://rp-database.com/docs/concepts/companies-contacts" target="_blank" rel="noopener noreferrer" class="title-docs" style="font-size: small;">Open Docs</a>
            </span>
          </div>
          <v-btn-toggle class="ml-2"
                        v-model="tableType"
                        tile
                        group
                        mandatory

          >
            <v-btn value="all">
              All
            </v-btn>

            <v-btn value="tenant">
              Tenants
            </v-btn>

            <v-btn value="landlord">
              Landlords
            </v-btn>

            <v-btn value="landlord_agent">
              Landlords Agent
            </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          <div class="fit-content ml-4" style="display: flex; float:right; align-items: center;">
            <v-switch v-if="isAdmin()" v-model="showUnverified" class="mr-4 align-center mt-0" hide-details
                      label="Unverified"></v-switch>
            <v-menu
              v-model="filtersMenu"
              :close-on-content-click="false"
              :nudge-width="300"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-badge class="mr-4" color="red" style="float:right" overlap bordered :value="filtersCount > 0">
                  <!-- <v-badge class="mr-4 ml-2 mt-1" style="float:right" overlap bordered :content="filtersCount" :value="filtersCount > 0"> -->
                  <v-btn height="40" outlined v-on="on">
                    <v-icon>mdi-table-search</v-icon> 
                    Filters
                  </v-btn>
                </v-badge>
              </template>

              <v-card>
                <v-card-title>
                  <h4 class="text-primary-700">Filters</h4>
                  <v-spacer></v-spacer>
                  <v-btn class="ml-2" outlined @click="resetFilters">
                    Reset
                  </v-btn>
                </v-card-title>
                <v-divider class="mx-2"></v-divider>
                <v-card-text class="rpd-filter-card-text pt-8 pb-2">
                  <v-autocomplete
                    v-model="isOutOfTownFilter"
                    :items="[{value:1, name:'Yes'}, {value:2, name:'No'}]"
                    cache-items
                    flat
                    hide-no-data
                    clearable
                    outlined dense
                    item-text="name"
                    item-value="value"
                    label="Out of town"
                    @change="getData"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-model="isLeisureFilter"
                    :items="[{value:1, name:'Yes'}, {value:2, name:'No'}]"
                    cache-items
                    flat
                    hide-no-data
                    clearable
                    outlined dense
                    item-text="name"
                    item-value="value"
                    label="Leisure"
                    @change="getData"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-model="isFoodStoreFilter"
                    :items="[{value:1, name:'Yes'}, {value:2, name:'No'}]"
                    cache-items
                    flat
                    hide-no-data
                    clearable
                    outlined dense
                    item-text="name"
                    item-value="value"
                    label="Foodstore"
                    @change="getData"
                  ></v-autocomplete>
                <v-autocomplete
                      v-model="categoriesFilter"
                      :items="categories"
                      label="Categories"
                      multiple
                      outlined
                      chips
                      clearable
                      item-text="name"
                      return-object
                      small-chips
                      deletable-chips
                      data-vv-name="form.categories"
                      data-vv-as="Categories"
                      no-data-text="No categories found"
                ></v-autocomplete>
                </v-card-text>
              </v-card>
            </v-menu>
            <v-btn height="40" class="mr-4 elevation-0" @click="exportCompanies" color="primary" :loading="isExporting">
              <span class="mr-2">Export</span>
              <v-icon size="20">mdi-file-excel</v-icon>
            </v-btn>
            <v-text-field
              class="py-2 fit-content"
              v-model="search"
              append-icon="mdi-table-search"
              label="Search"
              single-line
              clearable
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            style="border: 1px solid #e0e0e0; border-radius: 4px;"
            :headers="headers"
            :items="records"
            :options.sync="pagination"
            :loading="loading"
            :server-items-length="totalRecords"
            :items-per-page.sync="itemsPerPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :page.sync="page"
            :multi-sort="false"
            :footer-props="{
                            'items-per-page-options': [50, 100, 500],
                          }"

          >
  <!--          <template v-slot:header="{ props: { headers } }">-->
  <!--            <thead>-->
  <!--            <tr>-->
  <!--              <th v-for="h in headers">-->
  <!--                <v-tooltip bottom>-->
  <!--                  <template v-slot:activator="{ on }">-->
  <!--                    <span v-on="on">{{h.text}}</span>-->
  <!--                  </template>-->
  <!--                  <span>{{h.tooltip || h.text}}</span>-->
  <!--                </v-tooltip>-->
  <!--              </th>-->
  <!--            </tr>-->
  <!--            </thead>-->
  <!--          </template>-->
            <template v-slot:header.is_out_of_town="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">Out of town</span>
                </template>
                <span>This company has at least one property in an out of town retail park</span>
              </v-tooltip>
            </template>
            <template v-slot:header.is_leisure="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">Leisure</span>
                </template>
                <span>This company has at least one property on a leisure park</span>
              </v-tooltip>
            </template>
            <template v-slot:body="{ items }">
              <tbody v-if="initLoader">
                <tr v-for="n in 12" :key="n">
                  <td class="px-0 table-loading"  :colspan="headers.length">
                    <v-skeleton-loader
                      type="list-item"
                    ></v-skeleton-loader>
                  </td>
                </tr>
              </tbody>
              <tbody v-else-if="items.length > 0">
                <tr v-for="item in items" :key="item.id" class="row-link" @click="$refs.editCompanyDialog.showDialog(item.id)">
                  <!--<td>{{ item.id }}</td>-->
                  <td>
                    {{ item.name }}
                    <!-- <v-tooltip bottom v-if="item.core_id">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        small
                          :color="item.is_verified ? 'green' : 'orange lighten-1'"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-checkbox-marked-circle-outline
                        </v-icon>
                      </template>
                      <span v-if="item.is_verified">Verified Tracked Retailer</span>
                      <span v-else>This Tracked Retailer has not yet been Verified</span>
                    </v-tooltip> -->

                  </td>
                  <td>
                    <a @click.stop="$refs.companyInfoDialog.showDialog(item.id)">
                      {{ item.users_count }}
                    </a>
                  </td>
                  <td>{{ item.domain }}</td>
                  <td>{{ item.phone }}</td>
                  <td>
                    <a @click.stop="$refs.companyRequirementsDialog.showDialog(item.id)">
                      {{ item.requirements_count }}
                    </a>
                  </td>

                  <td v-if="tableType === 'tenant'">
                    <a @click.stop="$refs.companyPropertiesDialog.showDialog(item.id)">
                      {{ item.properties_count }}
                    </a>
                  </td>
                  <td v-if="tableType === 'tenant'"><v-icon style="font-size: 10px;" :color="item.is_out_of_town? 'green darken-1': 'red darken-1'">mdi-circle</v-icon></td>
                  <td v-if="tableType === 'tenant'"><v-icon style="font-size: 10px;" :color="item.is_leisure? 'green darken-1': 'red darken-1'">mdi-circle</v-icon></td>
                  <td v-if="tableType === 'tenant'"><v-icon style="font-size: 10px;" :color="item.is_food_store? 'green darken-1': 'red darken-1'">mdi-circle</v-icon></td>
                  <td v-if="tableType === 'landlord'">
                    <a @click.stop="$refs.companySchemesDialog.showDialog(item.id, 'landlord_schemes')">
                      {{ item.landlord_schemes_count }}
                    </a>
                  </td>
                  <td v-if="tableType === 'landlord_agent'">
                    <a @click.stop="$refs.companySchemesDialog.showDialog(item.id, 'landlord_agent_schemes')">
                      {{ item.landlord_agent_schemes_count }}
                    </a>
                  </td>

                  <!-- <td>
                      <template v-if="(item.scraper.data && item.scraper.data.verified_at) || item.scraper.verified_at">
                        <span v-if="item.is_verified">
                          {{ item.scraper.data.verified_at }} 
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <v-icon color="green darken-1" v-on="on">mdi-checkbox-marked-circle-outline</v-icon>
                            </template>
                            Up to date
                          </v-tooltip>
                        </span>
                        <span v-else>
                          {{ item.scraper.data.verified_at }}
                          <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon small color="orange lighten-1" v-on="on">mdi-check</v-icon>
                          </template>
                          Updating Soon
                        </v-tooltip>
                        </span>
                      </template>
                      <template v-else-if="item.core_id">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon color="grey" v-on="on">mdi-checkbox-marked-circle-outline</v-icon>
                          </template>
                          Coming Soon
                        </v-tooltip>
                      </template>
                  </td> -->

                  <td class="justify-center align-center layout px-2">
                    <v-icon v-if="isAdmin()" @click.stop="$refs.mergeCompaniesDialog.showDialog(item.id)"
                            small
                            class="mr-2 table-icon-btn"
                            title="Merge Companies"
                    >
                      mdi-merge
                    </v-icon>
                    <v-icon v-if="isAdmin() || clientId() === item.id || !item.is_registered" @click.stop="routeToEdit(item.id)"
                            small
                            class="mr-2 table-icon-btn"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon v-if="isAdmin()" @click.stop="deleteCompany(item.id, item.name)"
                            small
                            class="table-icon-btn"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                    <td class="text-center" :colspan="headers.length">
                        No records found
                    </td>
                </tr>
            </tbody>
            </template>
          </v-data-table>
        </v-card-text>
        <company-info-dialog ref="companyInfoDialog"></company-info-dialog>
        <company-requirements-dialog ref="companyRequirementsDialog"></company-requirements-dialog>
        <edit-company-dialog @closed="getData" @updated="getData" ref="editCompanyDialog"></edit-company-dialog>
        <merge-companies-dialog @saved="getData" ref="mergeCompaniesDialog"></merge-companies-dialog>
        <company-properties-dialog ref="companyPropertiesDialog"></company-properties-dialog>
        <company-schemes-dialog ref="companySchemesDialog"></company-schemes-dialog>
        <create-company-dialog ref="createCompanyDialog"></create-company-dialog>
        <!-- <v-btn
          fab
          dark
          bottom
          right
          fixed
          color="primary"
          @click="$refs.createCompanyDialog.showDialog()"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn> -->
    </v-col>
  </v-row>

</template>

<script>
import CompanyInfoDialog from '@/components/info/companyInfoDialog'
import CompanyPropertiesDialog from '@/components/info/companyPropertiesDialog'
import CompanySchemesDialog from '@/components/info/companySchemesDialog'
import MergeCompaniesDialog from "../../components/companies/mergeCompaniesDialog";
import EditCompanyDialog from "@/components/companies/editCompanyDialog";
import CompanyRequirementsDialog from "@/components/info/companyRequirementsDialog";
import CreateCompanyDialog from "@/components/companies/createCompanyDialog";

export default {
  components: {
    CreateCompanyDialog,
    CompanyRequirementsDialog,
    EditCompanyDialog,
    MergeCompaniesDialog,
    CompanyInfoDialog,
    CompanyPropertiesDialog,
    CompanySchemesDialog,
  },
  data() {
    return {
      filtersMenu: false,
      // isOutOfTownFilter: null,
      // isLeisureFilter: null,
      // isFoodStoreFilter: null,

      isExporting: false,
      showUnverified: false,
      // search: '',
      pagination: {},
      totalRecords: 0,
      loading: true,
      initLoader: true,
      sortBy: ['id'],
      sortDesc: [true],
      itemsPerPage: 50,
      page: 1,
      tableType: 'all',

      categories: [],
      categoriesFilter: [],

      headers: [
        {text: 'Name', value: 'name'},
        {text: 'No. of users', value: 'users_count'},
        {text: 'Domain', value: 'domain'},
        {text: 'Phone', value: 'phone'},
        {text: 'Requirements', value: 'requirements_count'},
        // {text: 'Verified', value: 'scraper.verified_at'},
        {text: 'Actions', sortable: false, align: 'center'}
      ],
      tenantHeaders: [
        {text: 'Properties', value: 'properties_count'},
        {text: 'Out of town', value: 'is_out_of_town', tooltip: 'This company has at least one property in an out of town retail park'},
        {text: 'Leisure', value: 'is_leisure', tooltip: 'This company has at least one property on a leisure park'},
        {text: 'Foodstore', value: 'is_food_store'},
      ],
      landlordHeaders: [
        {text: 'Schemes', value: 'landlord_schemes_count'},
      ],
      landlordAgentHeaders: [
        {text: 'Schemes', value: 'landlord_agent_schemes_count'},
      ],
      records: [],
      _timerId: null,
    }
  },
  mounted() {
    // this.getData()
    this.getCategories();
    this.handleRouteQuery();
  },
  watch: {
    pagination: {
      handler() {
        this.getData()
      },
      deep: true
    },
    search() {
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        this.page = 1
        this.getData()
      }, 500)
    },
    tableType(type) {
      this.headers = [
        {text: 'Name', value: 'name'},
        {text: 'No. of users', value: 'users_count'},
        {text: 'Domain', value: 'domain'},
        {text: 'Phone', value: 'phone'},
        {text: 'Requirements', value: 'requirements_count'},
        {text: 'Actions', sortable: false, align: 'center'}
      ];

      if (type === 'tenant') {
        this.headers.splice(5, 0, ...this.tenantHeaders);
      } else if (type === 'landlord') {
        this.headers.splice(5, 0, this.landlordHeaders[0]);
      } else if (type === 'landlord_agent') {
        this.headers.splice(5, 0, this.landlordAgentHeaders[0]);
      }
      this.getData()
    },
    showUnverified() {
      this.getData()
    },
    categoriesFilter() {
      this.getData()
    },
  },
  computed: {
    windowWidth() {
      return this.$vuetify.breakpoint.width;
    },

    isFiltersActive() {
      return this.isOutOfTownFilter !== null
        || this.isLeisureFilter !== null
        || this.isFoodStoreFilter !== null;
    },
    filtersCount() {
      let count = 0;
      if (this.isOutOfTownFilter !== null) count++;
      if (this.isLeisureFilter !== null) count++;
      if (this.isFoodStoreFilter !== null) count++;
      return count;
    },
    search: {
      get () {
        return this.$store.state.companies.filters.search
      },
      set (value) {
        this.$store.commit('updateCompaniesFilters', {key: 'search', value: value})
      }
    },
    isOutOfTownFilter: {
      get() {
        return this.$store.state.companies.filters.isOutOfTownFilter
      },
      set(value) {
        this.$store.commit('updateCompaniesFilters', {key: 'isOutOfTownFilter', value: value})
      }
    },
    isLeisureFilter: {
      get() {
        return this.$store.state.companies.filters.isLeisureFilter
      },
      set(value) {
        this.$store.commit('updateCompaniesFilters', {key: 'isLeisureFilter', value: value})
      }
    },
    isFoodStoreFilter: {
      get() {
        return this.$store.state.companies.filters.isFoodStoreFilter
      },
      set(value) {
        this.$store.commit('updateCompaniesFilters', {key: 'isFoodStoreFilter', value: value})
      }
    },
  },
  methods: {
    async getCategories() {
          await this.$http.get(`/company-categories`).then(response => {
          this.categories = response.data;
          });
      },

    async handleRouteQuery(){
      const query = this.$route.query;
      if (query.id) {
        this.$refs.editCompanyDialog.showDialog(query.id);
      }
    },
    resetFilters() {
      this.$store.commit('resetCompaniesFilters');
      this.getData()
    },
    routeToEdit(id) {
      // this.$router.push({name: 'companies.edit', params: {id: id}})
      this.$refs.editCompanyDialog.showDialog(id);
    },
    async deleteCompany(id, name) {
      this.$notify.question(`Do you want to remove ${name}?`, () => {
        this.$http.delete(`/companies/${id}`).then(() => {
          this.getData()
        })
      })
    },
    getData() {
      this.loading = true
      this.$http.get('/companies', {
        params: {
          q: this.search,
          page: this.pagination.page,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          per_page: this.pagination.itemsPerPage,
          type: this.tableType,
          include: 'users_count,properties_count,scraper',
          show_unverified: this.showUnverified ? 1 : 0,
          is_out_of_town: this.isOutOfTownFilter,
          is_leisure: this.isLeisureFilter,
          is_food_store: this.isFoodStoreFilter,
          category_ids: this.categoriesFilter.map(c => c.id)
        }
      }).then(response => {
        const pagination = response.data.meta.pagination
        this.totalRecords = pagination.total
        this.records = response.data.data
        this.loading = false
        this.initLoader = false
      }).catch(() => {
        this.loading = false
        this.initLoader = false
      })
    },
    exportCompanies() {
      this.isExporting = true;
      this.$http.get('/companies/export', {
        responseType: 'blob',
        params: {
          q: this.search,
          page: this.pagination.page,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          type: this.tableType,
        },
      }).then((response) => {
        this.isExporting = false;
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'companies.xlsx');
        document.body.appendChild(fileLink);
        fileLink.click();
      }).catch((e) => {
        this.isExporting = false;
      });
    },

    sortData(items, sortBy, sortDesc) {
        if (sortBy.length === 0) {
            return items
        }

        return items.sort((a, b) => {
            let sortA = a[sortBy[0]]
            let sortB = b[sortBy[0]]
            

            if (typeof sortA === 'string') {
                if((sortBy[0] == "verified_at" || sortBy[0] == "created_at") && sortA) {                   
                    if (sortA) {
                        let dateA = sortA.split('/')
                        sortA = parseFloat(dateA[2] + dateA[1] + dateA[0])
                    } else {
                        if (sortDesc[0]) {
                            sortA = 0
                        } else {
                            sortA = 99999999
                        }
                    }
                    if (sortB) {
                        let dateB = sortB.split('/')
                        sortB = parseFloat(dateB[2] + dateB[1] + dateB[0])
                    } else {
                        if (sortDesc[0]) {
                            sortB = 0
                        } else {
                            sortB = 99999999
                        }
                    }
                    console.log(sortA, sortB)
                }else{
                    return sortA.localeCompare(sortB) * (sortDesc[0] ? -1 : 1)
                }

            }

            return (sortA - sortB) * (sortDesc[0] ? -1 : 1)
        })
        
    },

  }
}
</script>

<style scoped>
.table-link {
  text-decoration: none;
}
</style>
